import { render, staticRenderFns } from "./Contratar2.vue?vue&type=template&id=21a82a3a&scoped=true&"
import script from "./Contratar2.vue?vue&type=script&lang=js&"
export * from "./Contratar2.vue?vue&type=script&lang=js&"
import style0 from "./Contratar2.vue?vue&type=style&index=0&id=21a82a3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a82a3a",
  null
  
)

export default component.exports